// extracted by mini-css-extract-plugin
export default {"container":"Rv05BvvR","toast":"NqIUWMhq","slideIn":"VCrDCmGg","avatar":"UmtTdEHg","content":"NP9KUrOv","name":"aT0viP8l","message":"bRFEtshr","close":"AGwmqghA"};